var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-aligned"},[_c('img',{staticClass:"background-image",style:(_vm.imgStyle),attrs:{"src":_vm.backgroundImg}}),_c('div',{staticClass:"text",style:(_vm.fontFamily)},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }